import React, {useEffect, useState} from 'react';
import Snackbar from '@mui/material/Snackbar';
import {Alert} from "@mui/material/";
import EventOverviewPerTime from "../buxliest/EventOverviewPerTime";

export interface IEventListByTimeProps {

}

const EventListByTime = (props: IEventListByTimeProps) => {
  const [excludeDates, setExcludeDates] = React.useState([])
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);

  const handleSnackbarClose = (event: any) => {
    setSnackbarOpen(false);
  };

  const addAttendeeSuccess = () => {
    setSnackbarOpen(true);
    const fakeExcludes = ['foo', ...excludeDates];
    setExcludeDates(fakeExcludes);
  };

  return (
    <>
      <EventOverviewPerTime excludeDates={excludeDates} registerSuccessCallback={addAttendeeSuccess}></EventOverviewPerTime>
      <Snackbar open={snackbarOpen} autoHideDuration={8000} onClose={handleSnackbarClose}>
        <Alert onClose={handleSnackbarClose} severity="success">
          Das hat funktioniert. Sie bekommen eine Bestätigung per E-Mail.
        </Alert>
      </Snackbar>
    </>

  );
}


export default EventListByTime;

